import React from 'react';
import Icon from '../../../components/AppIcon';

const milestones = [
  { label: 'Core Platform Built', icon: 'Code2', done: true, color: '#F58A54' },
  { label: 'Beta Testing Underway', icon: 'FlaskConical', done: true, color: '#F06F6B', active: true },
  { label: 'Vendor Network Expansion', icon: 'Building2', done: false, color: '#E0528A' },
  { label: 'Public Launch', icon: 'Rocket', done: false, color: '#F58A54' },
];

const LaunchProgress = () => {
  const completedCount = milestones?.filter((m) => m?.done)?.length;
  const progressPct = Math.round((completedCount / milestones?.length) * 100);

  return (
    <section className="py-16 bg-muted">
      <div className="max-w-4xl mx-auto px-4 lg:px-8">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-3">Development Progress</h2>
          <p className="text-text-secondary text-base">Here's where we are on the road to launch.</p>
        </div>

        {/* Progress bar */}
        <div className="mb-10">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm font-semibold text-foreground">Overall Progress</span>
            <span className="text-sm font-bold" style={{ color: '#F06F6B' }}>{progressPct}%</span>
          </div>
          <div className="h-3 bg-border rounded-full overflow-hidden">
            <div
              className="h-full rounded-full transition-all duration-700"
              style={{
                width: `${progressPct}%`,
                background: 'linear-gradient(90deg, #F58A54, #F06F6B, #E0528A)',
              }}
            />
          </div>
        </div>

        {/* Milestone grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {milestones?.map((m, i) => (
            <div
              key={i}
              className={`relative rounded-2xl p-5 border transition-all duration-300 ${
                m?.active
                  ? 'border-orange-300 shadow-md'
                  : m?.done
                  ? 'border-border' :'border-border opacity-60'
              }`}
              style={{ background: m?.done ? 'white' : '#f9fafb' }}
            >
              {m?.active && (
                <div
                  className="absolute -top-2.5 left-1/2 -translate-x-1/2 px-2.5 py-0.5 rounded-full text-white text-xs font-bold"
                  style={{ background: 'linear-gradient(90deg, #F58A54, #F06F6B)' }}
                >
                  Now
                </div>
              )}
              <div
                className="w-10 h-10 rounded-xl flex items-center justify-center mb-3"
                style={{ background: m?.done ? m?.color + '15' : '#f3f4f6' }}
              >
                <Icon name={m?.done ? m?.icon : 'Lock'} size={20} color={m?.done ? m?.color : '#9ca3af'} />
              </div>
              <p className="text-sm font-semibold text-foreground leading-snug">{m?.label}</p>
              <div className="mt-2 flex items-center gap-1.5">
                <Icon
                  name={m?.done ? 'CheckCircle2' : 'Circle'}
                  size={13}
                  color={m?.done ? '#22c55e' : '#d1d5db'}
                />
                <span className={`text-xs font-medium ${m?.done ? 'text-green-600' : 'text-text-secondary'}`}>
                  {m?.active ? 'In progress' : m?.done ? 'Complete' : 'Upcoming'}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LaunchProgress;
